module.exports = __webpack_public_path__ + "static/media/proveoppgave-1.3bce7c9f.mp3";